import React from "react";

import { Anchor, Group } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

const NoDataContainer = ({
  icon,
  text,
  linkText,
  onAnchorClick,
  hideAnchor = false,
  actionTestId,
}: {
  icon: React.ReactNode;
  text: string;
  linkText: string | React.ReactNode;
  onAnchorClick: () => void;
  hideAnchor?: boolean;
  actionTestId?: string;
}) => {
  return (
    <Group
      p="xs"
      gap="xs"
      w="100%"
      bg="gray.0"
      display="flex"
      justify="center"
      style={{ borderRadius: "var(--mantine-radius-xs)" }}
    >
      {icon}
      <TextWrapper fz="md" c="gray.7" variant="default">
        {text}
      </TextWrapper>
      {!hideAnchor && (
        // Rendered as a button: the action opens something in place rather than navigating, and a
        // button stays in the tab order where an anchor without an href would not.
        <Anchor
          fw="bold"
          size="sm"
          type="button"
          component="button"
          underline="always"
          onClick={onAnchorClick}
          data-testid={actionTestId}
        >
          {linkText}
        </Anchor>
      )}
    </Group>
  );
};

export { NoDataContainer };
